import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { LIST_VIEW_MODE } from 'Common/config';

export const ProviderCardWrapper = styled.div`
  container-name: provider-card;
  container-type: inline-size;
`;

export const ProviderCardListContainer = styled.div`
  container-name: provider-card-list;
  container-type: inline-size;
`;

export const ProviderCardList = styled.div<{
  mode: 'list' | 'grid';
}>`
  margin-bottom: ${fromTheme('spacing_xlarge')};

  ${(props) => {
    if (props.mode === LIST_VIEW_MODE.LIST) {
      return `
        display: flex;
        flex-direction: column;
        row-gap: ${fromTheme('spacing_medium')(props)};
      `;
    }

    const minGridCardSize = '425px';
    return `
      display: flex;
      flex-direction: column;
      row-gap: ${fromTheme('spacing_medium')(props)};

      @container provider-card-list (width >= ${minGridCardSize}) {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(${minGridCardSize}, 1fr));
        gap: ${fromTheme('spacing_medium')(props)};
        align-items: stretch;

        .provider-card {
          height: 100%;
          
          > div {
            height: 100%;
            grid-template-rows: auto;
          }
        }

        @container provider-card (width < 625px) {
          .booking-actions,
          .booking-availability-tiles,
          .provider-card-locations {
            align-content: end;
          }
        }
      }
    `;
  }}
`;
